import Link from 'next/link';
import { ARTICLE_TOKENS } from './design-tokens';

import { buildSanityImageUrl } from '@lib/sanity';
import type { SanityAuthor } from '@lib/sanity';

const AVATAR_WIDTH = 108;

type AuthorCardProps = {
  author: SanityAuthor;
  /** Overrides the standard bio; team reveals pass the author's reveal bio. */
  bio?: string;
};

export const AuthorCard = ({ author, bio = author.bio }: AuthorCardProps) => (
  <aside
    className={`mt-7 flex gap-[18px] rounded-[14px] border p-6 ${ARTICLE_TOKENS.rule}`}
    data-cy="article-author-card"
  >
    <span className="h-[54px] w-[54px] shrink-0 overflow-hidden rounded-full bg-[#dfe4e8]">
      {author.avatar?.asset && (
        <img
          src={buildSanityImageUrl(author.avatar)
            .width(AVATAR_WIDTH)
            .height(AVATAR_WIDTH)
            .url()}
          alt=""
          className="h-full w-full object-cover"
        />
      )}
    </span>
    <div>
      <div
        className={`mb-[5px] font-heading text-base font-bold ${ARTICLE_TOKENS.ink}`}
      >
        {author.name}
      </div>
      <p
        className={`m-0 text-[15px] leading-[1.5] ${ARTICLE_TOKENS.bodyMuted}`}
      >
        {bio}{' '}
        <Link
          href={`/author/${author.slug}`}
          className={ARTICLE_TOKENS.accentText}
        >
          All articles
        </Link>
      </p>
    </div>
  </aside>
);
